import { getApiEnvironmentConfig } from './api_environment';

export const get_api_url = (link, ignoredemail, isGo, absoluteUrl) => {
  const { apiDomain, mytChatHost, goDomain } = getApiEnvironmentConfig();

  if (link === 'mytChatUrl') {
    return mytChatHost;
  }

  if (isGo || link.startsWith('/v2')) {
    return `${goDomain}${link}`;
  }

  if (absoluteUrl) {
    return `${apiDomain}/${link}`;
  }

  return `${apiDomain}/cms/api/${link}`;
};

export const get_domain = () => {
  const { host } = window.location;
  const subdomain = host.split('.')[0];
  const urlDomain =
    subdomain === 'hridaya'
      ? 'https://myyogateacher.com'
      : 'https://student-testenv1.myyogateacher.com';

  return urlDomain;
};
